<template>
    <v-col>
        <v-row class="no-gutters align-center">
            <v-col class="pr-5 pr-md-0">
                <v-card class="transaction" flat dense>
                    <v-row no-gutters>
                        <div class="flex-shrink-1">
                            <v-card :class="status" min-width="10" height="100%" flat tile></v-card>
                        </div>
                        <v-col>
                            <v-row no-gutters class="align-stretch" :class="status">
                                <v-col class="flex-grow-0 pa-4 d-flex flex-column text-center transfer-status">
                                    <div class="flex-grow-1 mb-0 mb-md-4">
                                        <v-row no-gutters class="align-baseline justify-center">
                                            <v-chip :class="status" class="">
                                                <v-col class="text-right status pa-0">{{ status }}</v-col>
                                            </v-chip>
                                        </v-row>
                                        <v-row
                                            class="align-baseline justify-center"
                                            no-gutters
                                        >
                                            <p v-if="transfer.order_id" class="caption overline blue-grey--text text--darken-2 pt-4 pl-4 mb-0">{{ transfer.order_id }}</p>
                                            <p v-else class="caption overline blue-grey--text text--darken-2 pt-4 pl-4 mb-0">{{ transfer.id }}</p>
                                            <v-btn
                                                class="ml-2"
                                                icon
                                                @click="copyToClipboard(transfer.order_id || transfer.id)"
                                            >
                                                <v-icon small>
                                                    mdi-content-copy
                                                </v-icon>
                                            </v-btn>
                                        </v-row>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <div class="transfer-dates">
                                        <template v-if="transfer.posted_at">
                                            <div class="blue-grey--text text--darken-2">
                                                <p class="overline blue-grey--text lighten-4 mb-0">Posted</p>
                                                <p class="body-2 font-weight-medium mb-0">{{ transfer.posted_at | moment('l') }} {{ transfer.posted_at | moment('LT') }}</p>
                                            </div>
                                        </template>
                                        <template v-if="transfer.accepted_at">
                                            <div class="blue-grey--text text--darken-2">
                                                <p class="overline blue-grey--text lighten-4 mb-0">Accepted</p>
                                                <p class="body-2 font-weight-medium mb-0">{{ transfer.accepted_at | moment('l') }} {{ transfer.accepted_at | moment('LT') }}</p>
                                            </div>
                                        </template>
                                        <template v-if="transfer.confirmed_at && !isPoster">
                                            <div class="blue-grey--text text--darken-2">
                                                <p class="overline blue-grey--text lighten-4 mb-0">Confirmed</p>
                                                <p class="body-2 font-weight-medium mb-0">{{ transfer.confirmed_at | moment('l') }} {{ transfer.confirmed_at | moment('LT') }}</p>
                                            </div>
                                        </template>
                                        <template v-if="transfer.completed_at">
                                            <div class="blue-grey--text text--darken-2">
                                                <p class="overline blue-grey--text lighten-4 mb-0">Completed</p>
                                                <p class="body-2 font-weight-medium mb-0">{{ transfer.completed_at | moment('l') }} {{ transfer.completed_at | moment('LT') }}</p>
                                            </div>
                                        </template>
                                        <template v-if="transfer.cancelled_at">
                                            <div class="blue-grey--text text--darken-2">
                                                <p class="overline blue-grey--text lighten-4 mb-0">Cancelled</p>
                                                <p class="body-2 font-weight-medium mb-0">{{ transfer.cancelled_at | moment('l') }} {{ transfer.cancelled_at | moment('LT') }}</p>
                                            </div>
                                        </template>
                                        <template v-if="transfer.created_at">
                                            <div class="blue-grey--text text--darken-2">
                                                <p class="overline blue-grey--text lighten-4 mb-0">Created</p>
                                                <p class="body-2 font-weight-medium mb-0">{{ transfer.created_at | moment('l') }} {{ transfer.created_at | moment('LT') }}</p>
                                            </div>
                                        </template>
                                    </div>
                                </v-col>

                                <v-divider :vertical="$vuetify.breakpoint.lgAndUp" light class="flex-shrink-1" width="1px" color="#f5f5f5"></v-divider>

                                <v-col
                                    class="d-flex align-center justify-center mx-n1 pa-5 col-12"
                                    lg="7"
                                    md="4"
                                >
                                    <v-row class="align-center justify-center flex-row no-wrap px-8 py-4 no-gutters">
                                        <v-col>
                                            <v-row class="align-end">
                                                <v-col class="flex-shrink-1 d-flex flex-column align-center justify-left">
                                                    <div class="text-center text-lg-left">
                                                        <p class="overline blue-grey--text lighten-4 mb-0" style="line-height: 20px;">You sent</p>
                                                        <p class="headline subtitle-1 font-weight-medium mb-0" v-if="!isPoster">
                                                            {{ transfer.matcher_amount | currency }}<span class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1">{{ transfer.matcher_currency}}</span>
                                                        </p>
                                                        <p class="headline subtitle-1 font-weight-medium mb-0" v-else>
                                                            {{ getPosterAmount(transfer) | currency }}<span class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1">{{ transfer.poster_currency }}</span>
                                                        </p>
                                                    </div>
                                                </v-col>
                                                <v-col class="align-center justify-center flex-grow-1 col-12" lg="4">
                                                    <v-row class="d-flex flex-row flex-nowrap">

                                                        <v-col class="d-flex flex-grow-0 flex-shrink-1 align-center justify-center pa-0">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-avatar class="primary--outline" size="38" v-on="on">

                                                                        <!-- SENDING BANK ICON CHANGING NEEDS FUNCTIONALITY -->
                                                                        <v-icon color="primary" size="18">mdi-bank-outline</v-icon>

                                                                    </v-avatar>
                                                                </template>
                                                                    <span>Payment bank account</span>
                                                            </v-tooltip>
                                                        </v-col>

                                                        <v-col class="d-flex flex-grow-1 align-center justify-center pa-0">
                                                            <v-icon color="blue-grey lighten-4" size="10">mdi-chevron-double-right</v-icon>
                                                            <v-sheet color="blue-grey lighten-4" width="100%" height="2px"></v-sheet>
                                                        </v-col>

                                                        <v-col class="d-flex flex-grow-0 flex-shrink-1 align-center justify-center pa-0">

                                                            <!-- DURATION NEEDS FUNCTIONALITY -->
                                                            <v-chip outlined>0-1 days</v-chip>

                                                        </v-col>

                                                        <v-col class="d-flex flex-grow-1 align-center justify-center pa-0">
                                                            <v-sheet color="blue-grey lighten-4" width="100%" height="2px"></v-sheet>
                                                            <v-icon color="blue-grey lighten-4" size="10">mdi-chevron-double-right</v-icon>
                                                        </v-col>

                                                        <v-col class="d-flex flex-grow-0 flex-shrink-1 align-center justify-center pa-0">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-avatar class="primary--outline" size="38" v-on="on">

                                                                        <!-- RECIPIENT BANK ICON CHANGING NEEDS FUNCTIONALITY -->
                                                                        <v-icon color="primary" size="18">mdi-bank-outline</v-icon>

                                                                    </v-avatar>
                                                                </template>
                                                                    <span>Recipient bank account</span>
                                                            </v-tooltip>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col class="flex-shrink-1 text-right d-flex flex-column align-center justify-right">
                                                    <div class="text-center text-lg-right">
                                                        <p class="overline blue-grey--text lighten-4 mb-0" style="line-height: 20px;">
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, value, attrs }">
                                                                    <span
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        @click="(e) => {
                                                                            if (value) {
                                                                                return on.mouseleave(e);
                                                                            }

                                                                            return on.mouseenter(e);
                                                                        }"
                                                                    >
                                                                      {{ getRecipientName(transfer) }}
                                                                    </span>
                                                                </template>
                                                                <span v-if="isPoster">
                                                                    <li v-if="transfer.postersBeneficiary">
                                                                        {{ transfer.postersBeneficiary.full_name }}
                                                                    </li>
                                                                    <li v-if="transfer.postersBeneficiaryDeliveryMethod">
                                                                        {{ transfer.postersBeneficiaryDeliveryMethod.institution_name }}
                                                                    </li>
                                                                </span>
                                                                <ul v-if="!isPoster && matcherRecipient">
                                                                    <li>{{ matcherRecipient.name }}</li>
                                                                    <li v-if="matcherRecipient.institution_name">
                                                                        {{ matcherRecipient.institution_name }}
                                                                    </li>
                                                                    <li>{{ matcherRecipient.account_number }}</li>
                                                                </ul>
                                                            </v-tooltip> gets
                                                        </p>
                                                        <p class="headline subtitle-1 font-weight-medium mb-0" v-if="!isPoster">
                                                            {{ getPosterAmount(transfer) | currency }}<span class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1">{{ transfer.poster_currency }}</span>
                                                        </p>
                                                        <p class="headline subtitle-1 font-weight-medium mb-0" v-else>
                                                            {{ transfer.matcher_amount | currency }}<span class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1">{{ transfer.matcher_currency}}</span>
                                                        </p>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-row class="align-end justify-center">
                                                <v-col
                                                    class="flex-shrink-1 text-center d-flex flex-column align-center justify-center pa-0"
                                                    lg="4"
                                                    md="12"
                                                    sm="12"
                                                    xs="12"
                                                >
                                                    <div>
                                                        <p class="overline overline-xs blue-grey--text lighten-4 mb-0">
                                                            Exchange rate ({{ transfer.poster_currency }}/{{ transfer.matcher_currency }})
                                                        </p>
                                                        <p class="body-1 font-weight-medium mb-0">
                                                            {{ strongerExchangeRate(transfer) | currency }}
                                                        </p>
                                                    </div>
                                                </v-col>
                                                <template v-if="transfer.matcher_payment_method_fee">
                                                    <v-col
                                                        class="flex-shrink-1 text-center d-flex flex-column align-center justify-center pa-0"
                                                        lg="4"
                                                        md="12"
                                                        sm="12"
                                                        xs="12"
                                                    >
                                                        <div>
                                                            <p class="overline overline-xs blue-grey--text lighten-4 mb-0">
                                                                {{ transfer.matcherPaymentProvider ? transfer.matcherPaymentProvider.company.name : transfer.matcher_payment_provider }} fee
                                                            </p>
                                                            <p class="body-1 font-weight-medium mb-0">
                                                                {{ parseFloat(transfer.matcher_payment_method_fee).toFixed(2) }}<span class="pl-1 caption font-weight-regular teal--text lighten-1">{{ transfer.matcher_currency }}</span>
                                                            </p>
                                                        </div>
                                                    </v-col>
                                                    <v-col
                                                        class="flex-shrink-1 text-center d-flex flex-column align-center justify-center pa-0"
                                                        lg="4"
                                                        md="12"
                                                        sm="12"
                                                        xs="12"
                                                    >
                                                        <div>
                                                            <p class="overline overline-xs blue-grey--text lighten-4 mb-0">
                                                                Kaoshi fee
                                                            </p>
                                                            <p class="body-1 font-weight-medium mb-0">
                                                                {{ parseFloat(transfer.matcher_fee || 0).toFixed(2) }}
                                                                <span class="pl-1 caption font-weight-regular teal--text lighten-1">{{ transfer.pb_currency }}</span>
                                                            </p>
                                                        </div>
                                                    </v-col>
                                                </template>

                                                <template v-if="transfer.matcher_fee && !transfer.matcher_payment_method_fee">
                                                    <v-col
                                                        class="flex-shrink-1 text-center d-flex flex-column align-center justify-center pa-0"
                                                        lg="4"
                                                        md="12"
                                                        sm="12"
                                                        xs="12"
                                                    >
                                                        <div>
                                                            <p class="overline overline-xs blue-grey--text lighten-4 mb-0">
                                                                Transfer fee
                                                            </p>
                                                            <p class="body-1 font-weight-medium mb-0">
                                                                {{ parseFloat(transfer.matcher_fee).toFixed(2) }}<span class="pl-1 caption font-weight-regular teal--text lighten-1">{{ transfer.matcher_currency }}</span>
                                                            </p>
                                                        </div>
                                                    </v-col>
                                                </template>
                                                <template v-if="transfer.fake_fee">
                                                    <v-col
                                                        class="flex-shrink-1 text-center d-flex flex-column align-center justify-center pa-0"
                                                        lg="4"
                                                        md="12"
                                                        sm="12"
                                                        xs="12"
                                                    >
                                                        <div>
                                                            <p class="overline overline-xs blue-grey--text lighten-4 mb-0">
                                                                Transfer fee
                                                            </p>
                                                            <p class="body-1 font-weight-medium mb-0">
                                                                {{ parseFloat(transfer.fake_fee).toFixed(2) }}<span class="pl-1 caption font-weight-regular teal--text lighten-1">{{ transfer.matcher_currency }}</span>
                                                            </p>
                                                        </div>
                                                    </v-col>
                                                </template>
                                            </v-row>
                                            <v-row class="align-end justify-center" v-if="transfer.memo && transfer.memo.length > 0">
                                                <v-col class="flex-shrink-1 text-center d-flex flex-column align-center justify-center pa-0 pa-lg-3 col-12" lg="6">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, value, attrs }">
                                                            <v-btn
                                                                color="primary"
                                                                text
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                @click="(e) => {
                                                                    if (value) {
                                                                        return on.mouseleave(e);
                                                                    }

                                                                    return on.mouseenter(e);
                                                                }"
                                                            >
                                                                See Memo
                                                            </v-btn>
                                                        </template>
                                                        <span>{{ transfer.memo }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <div
                                                        v-if="status === 'payment received'"
                                                        class="grey--text mt-2 text-center"
                                                    >
                                                        <a
                                                            class="text-decoration-underline"
                                                            @click="showPaymentReceivedModal"
                                                        >
                                                            Why is my swap not completed?
                                                        </a>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col class="d-flex justify-center align-center flex-column pa-2">
                                    <template v-if="canPay">
                                        <v-btn
                                            v-if="status === 'unpaid'"
                                            color="primary"
                                            dark
                                            depressed
                                            large
                                            width="170px"
                                            @click="payButtonClicked(transfer)"
                                        >
                                            Payment Details
                                        </v-btn>
                                    </template>

                                    <template v-if="isPoster && status === 'unpaid'">
                                        <v-btn
                                            color="primary"
                                            @click="posterPayButtonClicked"
                                            dark
                                            depressed
                                            large
                                            width="170px"
                                        >
                                            Pay
                                        </v-btn>
                                    </template>

                                    <template v-if="isPoster && status === 'unpaid'">
                                        <v-btn
                                            color="primary"
                                            @click="posterPaidButtonClicked"
                                            dark
                                            depressed
                                            large
                                            width="170px"
                                        >
                                            I have paid
                                        </v-btn>
                                    </template>

                                    <template
                                        v-if="transfer.is_confirmed && !isPoster && !transfer.is_cancelled && !transfer.is_completed && !transfer.order.unified_recipient_id">
                                        <v-btn
                                            v-if="status === 'unpaid'"
                                            color="primary"
                                            @click="validateTransaction"
                                            dark
                                            depressed
                                            large
                                            width="170px"
                                            class="paid-button mt-3"
                                        >
                                            Paid
                                        </v-btn>
                                        <span v-if="status === 'unpaid'" class="mt-2 flashing-text">
                                            Click this button <br/>if you have paid
                                        </span>
                                    </template>

                                    <v-btn
                                        v-if="canCancelMatch"
                                        @click.prevent="cancelMatch"
                                        text
                                        color="red darken-2"
                                        large
                                        width="170px"
                                        class="px-2 mt-4"
                                    >
                                        Cancel transfer
                                    </v-btn>

                                    <v-btn
                                        v-if="canCancelOrder"
                                        @click.prevent="cancelTransfer(transfer)"
                                        text
                                        color="red darken-2"
                                        large
                                        width="170px"
                                        class="px-2 mt-4"
                                    >
                                        Cancel transfer
                                    </v-btn>

                                    <template v-if="transfer.company && transfer.company.logo">
                                        <v-img
                                            width="150" contain
                                            :src="transfer.company.logo"
                                        ></v-img>
                                    </template>

                                    <v-btn
                                        v-if="isPoster || (!isPoster && transfer.completed_at)"
                                        color="primary"
                                        dark
                                        large
                                        width="170px"
                                        class="px-2 mt-4"
                                        @click="$emit('openMemoDialog')"
                                    >
                                        {{ transfer.memo ? 'Update' : 'Add' }} memo
                                    </v-btn>

                                    <v-btn
                                        v-if="(transfer.completed_at || transfer.removed_at) && isPoster"
                                        color="primary"
                                        :href="`/offers/new?original-id=${transfer.id}`"
                                        large
                                        width="170px"
                                        class="px-2 mt-4 white--text"
                                    >
                                        Repeat
                                    </v-btn>

                                    <v-card-actions v-if="isShareShown">
                                        <v-btn
                                            class="mt-4"
                                            depressed
                                            @click="showTransferShareDialog = true"
                                        >
                                            Share
                                        </v-btn>
                                    </v-card-actions>

                                    <v-card-actions v-if="transfer.completed_at">
                                        <ShareNetwork
                                            network="twitter"
                                            :url="sharedUrl"
                                            :title="sharedText"
                                            twitter-user="KaoshiNetwork"
                                            class="v-btn v-btn--contained v-btn--fab v-btn--round
                                            theme--light v-size--small primary"
                                        >
                                            <v-icon color="white">
                                                mdi-twitter
                                            </v-icon>
                                        </ShareNetwork>

                                        <ShareNetwork
                                            network="facebook"
                                            :url="sharedUrl"
                                            :title="sharedText"
                                            :quote="sharedText"
                                            hashtags="KaoshiNetwork"
                                            class="v-btn v-btn--contained v-btn--fab v-btn--round
                                            theme--light v-size--small primary"
                                        >
                                            <v-icon color="white">
                                                mdi-facebook
                                            </v-icon>
                                        </ShareNetwork>
                                    </v-card-actions>

                                    <p
                                        v-if="transfer.completed_at"
                                        class="teal--text lighten-1 text-center"
                                    >
                                        Spread the good news of Kaoshi to your friends and family.
                                    </p>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <TransferShareDialog
            v-model="showTransferShareDialog"
            :order="transfer"
        />
    </v-col>
</template>

<script>
    /* eslint-disable camelcase */
    import TransferShareDialog from './transfers/components/transfer-share-dialog.vue';

    let currency = require('../modules/currency.js');

    export default {
        components: {
            TransferShareDialog,
        },
        data: () => ({
            sharedUrl: 'https://kaoshinetwork.com',
            showTransferShareDialog: false,
        }),
        props: getProps(),
        methods: getMethods(),
        computed: getComputed(),
        mounted,
    };

    function mounted() {
        const { orderId, action } = this.$route.params;
        if (action === 'pay') {
            if (this.canPay && orderId === this.transfer.order_id) {
                this.payButtonClicked(this.transfer);
            }
        }

        console.log('mounted', {
            transfer: this.transfer,
            isPoster: this.isPoster,
            canPay: this.canPay,
        })
    }

    function getProps() {
        return {
            transfer: {},
            isPoster: {
                type: Boolean,
                default: false,
            },
            cancelledCountInLast30Days: {
                type: Number,
                default: 2,
            },
        };
    }

    function getMethods() {
        return {
            getAvatarLink,
            strongerExchangeRate,
            cancelTransfer,
            getCurrencyFromCode,
            payButtonClicked,
            validateTransaction,
            getRecipientName,
            posterPayButtonClicked,
            posterPaidButtonClicked,
            cancelMatch,
            getPosterAmount(transfer) {
              const {
                  match,
                  matcher_payment_completed_at: matcherPaymentCompletedAt,
                  is_partial_match_allowed: isPartialMatchAllowed,
              } = transfer;

              if (match && isPartialMatchAllowed && matcherPaymentCompletedAt) {
                return match.poster_amount;
              }

              return transfer.poster_amount;
            },
            showPaymentReceivedModal() {
                this.$swal({
                    type: 'warning',
                    title: 'Payment Received',
                    text: `When a swap is on Payment Received,
                    this means the bank holding the fund is releasing the fund to your recipient's account.
                    Rest assured the fund is on its way.`,
                });
            },
        };

        function getAvatarLink(user) {
            var link;

            if (!user) {
                link = null;
            } else if (!!user.avatar) {
                link = user.avatar;
            } else {
                link = null;
            }
            return link;
        }

        function strongerExchangeRate(match){
            if (match.exchange_rate < 1) {
                if (match.exchange_rate === 0){
                    return 0;
                } else {
                    return 1 / match.exchange_rate;
                }
            } else {
                return match.exchange_rate;
            }
        }

        function cancelTransfer(transfer){
            this.$emit('cancelTransfer', transfer);
        }

        function getCurrencyFromCode(currencyCode){
            var c = currency.findCurrency(currencyCode);
            c = currency.addCurrencySteps(c);
            c = currency.addFlagLink(c);
            return c;
        }

        function payButtonClicked(transfer) {
            const vm = this;
            vm.$emit('update:selectedOrder', transfer);
            vm.$emit('open-make-payment');
        }

        async function validateTransaction() {
            let message = `made payment and confirmed that the money has left your
                bank account to your matched peer's bank account`;

            const { isNgHybrid, order } = this.transfer;

            if (order.type === 'hybrid' && !isNgHybrid) {
                const {
                    matcher_fee: matcherFee,
                    pb_amount: pbAmount,
                    pb_currency: pbCurrency,
                    matcherPaymentProvider,
                } = this.transfer;

                const { company } = matcherPaymentProvider || {};
                const amount = parseFloat(pbAmount) + parseFloat(matcherFee);
                message = `made payment and confirmed that ${company.name}
                    <img src="${company.logo}" style="height: 17px; display: inline-block;"/>
                    sent ${pbCurrency} ${amount.toFixed(2)}
                    to your matched peer's domiciliary bank account`;
            }

            const html = `
                <h2 class="blinking-title" style="margin-bottom: 5px">Attention!</h2>
                <p style="margin-bottom: 8px;">
                    By clicking this button, you affirm that you have
                    <span style="font-weight: 600">${message}</span>.
                </p>
                <p>
                    Falsely affirming an unpaid transaction could result in account suspension.
                </p>`;

            const { value: affirmed } = await this.$swal({
                type: 'warning',
                customClass: 'blinking-alert',
                html,
                showCancelButton: true,
            });

            if (!affirmed) {
                return false;
            }

            let payload = {};
            if (order.type === 'hybrid' && !isNgHybrid) {
                const {
                    matcherPaymentProvider,
                } = this.transfer;
                const { company } = matcherPaymentProvider || {};
                const { value: is_coupon_used } = await this.$swal({
                    showCancelButton: true,
                    showConfirmButton: true,
                    cancelButtonText: 'No',
                    confirmButtonText: 'Yes',
                    allowOutsideClick: false,
                    type: 'info',
                    title: 'Did you use a coupon on',
                    html: `<img width="150" src="${company.logo}"/>`,
                });

                payload = {
                    is_coupon_used,
                };
            }

            this.$emit('validateTransaction', payload);
        }

        function getRecipientName(transfer) {
            let name = 'Recipient';

            if (!this.isPoster && this.matcherRecipient) {
                name = this.matcherRecipient.name.split(' ')[0] || name;
            }

            const { postersBeneficiary } = transfer;
            if (!postersBeneficiary) {
                return name;
            }

            return postersBeneficiary.firstname || name;
        }

        function posterPayButtonClicked() {
            this.$emit('update:selectedOrder', this.transfer);
            this.$emit('openManualPaymentDialog');
        }
        async function posterPaidButtonClicked() {
            try {
                this.$emit('loading');
                const { id } = this.transfer;
                const { data } = await Vue.backendApi().order(id).verifyPosterPayment();
                const { status } = data;

                await this.$swal({
                    type: 'success',
                    title: `Payment is ${status}`,
                });
            } catch (err) {
                if (err.toLowerCase() === 'payment not received') {
                    this.$swal({
                        type: 'error',
                        title: 'Payment Not Received',
                    });
                } else {
                  this.$swal({
                      type: 'error',
                      title: 'Error Verifying Payment',
                      text: err,
                  });
                }
            } finally {
                this.$emit('loaded');
            }
        }

        async function cancelMatch() {
            if (this.cancelledCountInLast30Days >= 2) {
                return;
            }

            const { value } = await this.$swal({
                type: 'warning',
                customClass: 'blinking-alert',
                title: 'Are you sure you want to cancel?',
                text: `You can only cancel transfers twice a month.
                        All transfers are compulsory after the second
                        cancel or your account gets suspended.`,
                showCancelButton: true,
            });

            if(value) {
                try {
                    this.$emit('loading');
                    await Vue.backendApi().pendingMatches(this.transfer.id).rejectPendingMatch();
                    this.loading = false;
                    this.$swal({
                        type: 'success',
                        title: 'Transfer cancelled',
                    });
                } catch (err) {
                    this.$swal({
                        type: 'error',
                        title: 'Error rejecting transfer',
                        text: err,
                    });
                } finally {
                    this.$emit('loaded');
                }
            }
        }
    }

    function getComputed() {
        return {
            status,
            strongerCurrencyTradeAmount,
            strongerCurrencyCode,
            getMatcherCurrencyCode,
            canPay,
            posterCountry,
            matcherCountry,
            sharedText,
            matcherRecipient,
            canCancelMatch() {
              if (this.isPoster) {
                  return false;
              }

              if (this.cancelledCountInLast30Days >= 2) {
                  return false;
              }

              if (this.transfer.order.probably_paid) {
                  return false;
              }

              if (this.status !== 'unpaid') {
                  return false;
              }

              return true;
            },
            canCancelOrder() {
              if (!this.isPoster) {
                  return false;
              }

              if (this.transfer.cancelled_at) {
                  return  false;
              }

              if (this.transfer.is_removed) {
                  return false;
              }

              return this.transfer.can_cancel_order;
            },
            isShareShown() {
                return this.transfer.type === 'p2p'
                    && this.status === 'processing'
                    && this.isPoster;
            },
        };

        function status() {
            // 3pos
            if (this.transfer.recipient) {
                return this.transfer.status;
            }

            if ( this.isPoster ) {
                if ( this.transfer.is_cancelled ) {
                    return 'cancelled';
                } else if ( this.transfer.is_completed ) {
                    return 'completed';
                } else if ( this.transfer.matcher_payment_completed_at !== null ) {
                    return 'completed';
                } else if ( this.transfer.is_removed ) {
                    let status = 'expired';

                    if (this.transfer.refunded_at) {
                        status = `${status} and refunded`;
                    }

                    return status;
                } else if ( this.transfer.is_confirmed ) {
                    return 'processing';
                } else if ( this.transfer.is_accepted ) {
                    return 'processing';
                } else if (!this.transfer.is_paid_by_poster) {
                    return 'unpaid';
                } else {
                    return 'processing';
                }
            } else {
                if ( this.transfer.is_cancelled ) {
                    return 'cancelled';
                } else if ( this.transfer.is_completed ) {
                    return 'completed';
                } else if ( this.transfer.matcher_payment_completed_at !== null ) {
                    return 'payment received';
                } else if ( this.transfer.is_completed ) {
                    return 'completed'
                } else if ( this.transfer.is_confirmed ) {
                    return 'unpaid';
                } else if ( this.transfer.is_accepted ) {
                    return 'unpaid';
                } else {
                    return 'unpaid';
                }
            }
        }

        /**
         * This USED TO attempt to return the "stronger" currency; it now just returns the matcher's currency.
         *
         * @returns {number|*}
         */
        function strongerCurrencyTradeAmount(){
            return getMatcherAmount(this);
        }

        /**
         * Returns the matcher amount.
         *
         * @param that
         * @returns {number|*}
         */
        function getMatcherAmount(that) {
            return that.transfer.matcher_amount;
        }

        /**
         * This USED TO attempt to return the "stronger" currency symbol; it now just returns the matcher's currency symbol.
         *
         * @returns {*}
         */
        function strongerCurrencyCode() {
            return getMatcherCurrencyCode(this);
        }

        /**
         * Returns the matcher currency code (i.e. symbol).
         *
         * e.g. $ etc.
         *
         * @param that
         * @returns {string|*}
         */
        function getMatcherCurrencyCode(that) {
            return that.transfer.matcher_currency;
        }

        function canPay() {
          return this.transfer.is_confirmed
              && !this.isPoster
              && !this.transfer.is_cancelled
              && !this.transfer.is_completed;
        }

        function posterCountry() {
            let {
                // eslint-disable-next-line prefer-const
                order,
                poster_country,
            } = this.transfer;

            if (order) {
                poster_country = order.poster_country;
            }

            return this.countries.find((country) => country.iso2 === poster_country);
        }

        function matcherCountry() {
            let {
                order, // eslint-disable-line prefer-const
                match, // eslint-disable-line prefer-const
                matcher_country,
            } = this.transfer;

            if (match && match.matcher_country) {
                matcher_country = match.matcher_country;
            }

            if (order && order.matcher_country) {
                matcher_country = order.matcher_country;
            }

            return this.countries.find((country) => country.iso2 === matcher_country);
        }

        function sharedText() {
            const {
                poster_currency,
                matcher_currency,
            } = this.transfer;
            const fromCountry = this.isPoster ? this.posterCountry : this.matcherCountry;
            const toCountry = this.isPoster ? this.matcherCountry : this.posterCountry;
            const exchangeRate = this.strongerExchangeRate(this.transfer);

            if (fromCountry && toCountry) {
                return `OMG! I just sent money from ${fromCountry.name} to ${toCountry.name} at ${exchangeRate} ${poster_currency}/${matcher_currency}. Kaoshi is the best way to send money from ${fromCountry.name} to ${toCountry.name}. The exchange rates are unbeatable. Guys you need to try it out!`;
            }
            return '';
        }

        function matcherRecipient() {
          if (this.isPoster) {
              return null;
          }

          const { matcherRecipient } = this.transfer;
          if (!matcherRecipient) {
              return null;
          }

          const {
              recipient,
              institution_name,
          } = matcherRecipient;
          if (!recipient) {
              return null;
          }

          const { recipientInfo } = recipient;
          if (!recipientInfo) {
              return null;
          }

          return {
              ...recipientInfo,
              institution_name,
          };
        }
    }
</script>

<style scoped>
a {
    color: inherit; /* blue colors for links too */
    text-decoration: inherit; /* no underline */
}

.transfer-status {
    min-width: 375px;
}

@media screen and (min-width: 767px) {
    .transfer-status {
        min-width: 250px;
    }
}

.statusBar {
    position: absolute;
    top: 0;
    width: 100%;
    color: #cfd8dc;
}

/* Processing & Unpaid */
.v-card.processing, .v-card.unpaid {
    background-color: #dde !important;
    border-color: #dde !important;
    color: #000000aa !important;
}

.v-chip.processing, .v-chip.unpaid {
    background: #dde !important;
    color: #000000aa !important;
}

/* Payment Received */
.v-card.received {
    background-color: #FDD835 !important;
    border-color: #FDD835 !important;
    color: #000000aa !important;
}

.v-chip.received {
    background: #FDD835 !important;
    color: #000000aa !important;
}

/* Completed */
.v-card.completed {
    background-color: #0cd6c0 !important;
    border-color: #0cd6c0 !important;
    color: #000000aa !important;
}

.v-chip.completed {
    background: #0cd6c0 !important;
    color: #000000aa !important;
}

/* Cancelled */
.v-card.cancelled,
.v-card.failed,
.v-card.expired {
    background-color: #FF8A80 !important;
    border-color: #FF8A80 !important;
    color: #bbb !important;
}

.v-chip.cancelled {
    background: #FF8A80 !important;
    color: #000000aa !important;
}

.cancelled i.v-icon.notranslate.mdi.mdi-bank-outline.theme--light.primary--text,  .cancelled p, .cancelled span {
    color: #bbb !important;
    caret-color: #bbb !important;
}

.cancelled .primary--outline {
    border: 2px solid #bbb;
}

.theme--light.v-divider {
    border-color: rgba(0,0,0,0.02);
}

.transaction {
    overflow: hidden;
}

.primary--outline {
    background-color: transparent;
    border: 2px solid #3F51B5;
}



.transfer-dates > div {
    margin-bottom: 16px;
}

.transfer-dates :last-child {
    margin-bottom: unset;
}
</style>
<style lang="scss" scoped>
.paid-button {
    animation: shadow-pulse 1s infinite;
}

.flashing-text {
    font-size: 13px;
    color: red;
}

.v-application .overline.overline-xs {
  font-size: 11px !important;
}

@keyframes shadow-pulse
{
    0% { transform: scale(1); }
    30% { transform: scale(1); }
    40% { transform: scale(1.08); }
    50% { transform: scale(1); }
    60% { transform: scale(1); }
    70% { transform: scale(1.05); }
    80% { transform: scale(1); }
    100% { transform: scale(1); }
}
</style>
